export default {
  messageGroupContainer: { display: "flex", alignItems: "flex-end" },
  userMessageGroupContainer: {
    display: "flex",
    alignItems: "flex-end",

    flexDirection: "column",
  },
  messageGroup: { width: "fit-content", margin: "0 14px 0 10px" },
  image: { borderRadius: "50%", backgroundColor: "transparent" },
};
